import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { useCallback } from 'react';
// @ts-expect-error module not typed
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedMoveToInboxCommentInput } from '../../usage-tracking/utils/threadInteraction';
import { jsx as _jsx } from "react/jsx-runtime";
const MoveToInboxAddComment = ({
  comment,
  setComment
}) => {
  const handleCommentOnChange = useCallback(evt => setComment(evt.target.value), [setComment]);
  const handleCommentInputOnClick = useCallback(() => {
    trackEvent(getClickedMoveToInboxCommentInput());
  }, []);
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-4 m-bottom-4",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.commentInputTitle"
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "move-to-inbox-comment-input",
      value: comment,
      onChange: handleCommentOnChange,
      onClick: handleCommentInputOnClick
    })
  });
};
MoveToInboxAddComment.displayName = 'MoveToInboxAddComment';
export default MoveToInboxAddComment;